export default "__VITE_ASSET__CBBJ50IC__"